import { useContext, useEffect, useState, useRef, dangerouslySetInnerHTML } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { FeatureContext } from '../model/FeatureProvider';
import Modal from './Modal';
import { tabList } from '../model/StaticVariables';
import DragContainer from './DragContainer';
import { useMouseDown } from '../controller/useMouseDown';
import { getStateName, getCountyName } from '../model/StaticVariables';
import { pointWithinDomElement } from '../controller/CollisionDetection';

//ΔVΔVΔ: Deselect any text selected by user cursor
const clearSelection = () => {
    if (window.getSelection) {
        window.getSelection().removeAllRanges();
    } else if (document.selection) {
        document.selection.empty();
    }
};
const POIFeatureModalContent = (props) => {
    const { feature } = props;
    if (!feature || !feature.get('info')) return null;

    const {
        data,
        info: { label },
        count
    } = feature.values_;

    const poiListItem = (data) => {
        const { NAME, ADDRESS, ZIP, CITY, STATE } = data;
        return (
            <p>
                <strong>{NAME} </strong>
                <br />
                {ADDRESS}
                <br />
                {CITY} {STATE}, {ZIP}
            </p>
        );
    };

    return (
        <div>
            <h3>
                {label} ({count})
            </h3>
            <hr />
            <div className="poilist">
                {data.map((poi, i) => {
                    return poiListItem(poi);
                })}
            </div>
        </div>
    );
};
//**if scope state, year changes and it's svi remove window
const SVIFeatureModalContent = (props) => {
    const { feature } = props;
    const { theme, year, setSelectedTab, setHighlightedFips, scope, setPreparedMapChoice } = useContext(InterfaceContext);
    const vulnerability_txt = {
        //none low med high top
        top: 'high',
        high: 'medium to high',
        med: 'low to medium',
        low: 'low',
        none: 'none'
    };

    if (!feature || !feature.get('FIPS')) return null;

    const gotoTableFips = () => {
        setSelectedTab(tabList[1]);
        setHighlightedFips(feature.get('FIPS'));
    };

    const goToPreparedMap = async (e) => {
        e.preventDefault();
        const fips = feature.get('FIPS');

        const county = getCountyName(fips)
            .replace(/county/gi, '')
            .trim();
        const usstate = getStateName(fips);

        setPreparedMapChoice({ usstate, county });
        setTimeout(() => {
            var link = document.querySelector('[name=preparedcountymaps]');
            var y = link.getBoundingClientRect().y;
            document.body.scrollTop = y;
            window.scroll({
                top: y,
                behavior: 'smooth'
            });
        }, 300);
    };
    const fips = feature.get('FIPS');
    const countyName = getCountyName(fips);
    const stateName = getStateName(fips);
    const geolevel = String(fips).length === 5 ? 'county' : 'census';

    const allvals = feature.get('sviValues') || '';
    const sviValNum = allvals['theme' + theme.id + 'Num'];
    const sviValSlug = allvals['theme' + theme.id];
    const vulnerableText = vulnerability_txt[sviValSlug];
    const scopetext = scope === 'national' ? 'National' : 'Statewide';

    //Does the modal update when theme changes?=ye
    return (
        <div>
            <h3>
                {geolevel === 'census' && (
                    <>
                        <span> Census Tract {fips}, </span>
                        <br />
                    </>
                )}
                <span dangerouslySetInnerHTML={{ __html: countyName }}></span>, {stateName}
            </h3>
            <hr />
            {sviValNum === -999 && <h4>Data unavailable from the Census to calculate this variable.</h4>}
            {sviValNum !== -999 && (
                <>
                    <h4>
                        {year.label} {scopetext} {theme.label} Score:
                    </h4>
                    <p>
                        <strong>{sviValNum}</strong>
                    </p>
                    <p>Possible scores range from 0 (lowest vulnerability) to 1 (highest vulnerability).</p>
                    <p>
                        A score of <strong>{sviValNum}</strong> indicates a <strong>{vulnerableText}</strong> level of vulnerability.
                    </p>
                    <a id="preparedMaps" href="" onClick={goToPreparedMap}>
                        View Prepared County Map
                    </a>
                    <button className="view-table-btn" onClick={gotoTableFips}>
                        View in Table
                    </button>
                </>
            )}
        </div>
    );
};

const FeatureModal = (props) => {
    const { visible, feature, onClose } = props;
    const [type, setType] = useState('county');

    const getFeatureSlug = (feature) => {
        if (feature.get('poi')) {
            return feature.values_.info?.slug || 'poi';
        } else {
            const fipsNum = feature.get('FIPS');
            return fipsNum.length > 5 ? 'census' : 'county';
        }
    };

    useEffect(async () => {
        if (!feature) return;
        setType(getFeatureSlug(feature));
    }, [feature]);

    return (
        <>
            <div id={`feature-window`} className={`info-box-pop ${visible ? 'show' : ''} ${type}`}>
                <Modal delay={false} pixelCoords={[0, 0]} visible={visible} pinned={true} onClose={onClose}>
                    <POIFeatureModalContent feature={feature} />
                    <SVIFeatureModalContent feature={feature} />
                </Modal>
            </div>
        </>
    );
};
export { FeatureModal };

const HoveredFeatureModal = () => {
    const { modalIsPinned, pinWindow, pinnedFeature } = useContext(FeatureContext);
    const { year, scope, usState, tract } = useContext(InterfaceContext);
    const windowRef = useRef();
    const isOpen = useRef(false);
    const lastClick = useMouseDown();
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

    const closeThisWindow = () => {
        pinWindow(false);
        isOpen.current = false;
        setIsDragging(false);
    };

    const mouseup = (e) => {
        setDragOffset({ x: 0, y: 0 });
        setIsDragging(false);
    };

    const getLastClickOffset = () => {
        const dragBarRect = windowRef.current.querySelector('.drag-bar').getBoundingClientRect();
        return { x: dragBarRect.x - lastClick.x, y: dragBarRect.y - lastClick.y };
    };

    useEffect(() => {
        if (!modalIsPinned) return;
        if (!lastClick.x || !windowRef.current) return;
        const dragbarClicked = pointWithinDomElement(lastClick.x, lastClick.y, windowRef.current.querySelector('.drag-bar'));
        setDragOffset(getLastClickOffset());
        setIsDragging(dragbarClicked);
    }, [lastClick]);

    useEffect(() => {
        if (isDragging) clearSelection();
    }, [isDragging]);

    useEffect(() => {
        if (!pinnedFeature) {
            closeThisWindow();
            return;
        } else if (!isOpen.current) {
            isOpen.current = true;
            setDragOffset(lastClick);
        }
    }, [pinnedFeature]);

    useEffect(() => {
        closeThisWindow();
    }, [year, scope, usState, tract]);

    useEffect(() => {
        document.addEventListener('mouseup', mouseup);
        return () => {
            document.removeEventListener('mouseup', mouseup);
        };
    }, []);
    if (!modalIsPinned) return null;
    return (
        <>
            <DragContainer className={'feature-window'} dragging={isDragging} verbose={true} offset={dragOffset}>
                <div ref={windowRef} className={'window-container'}>
                    <FeatureModal visible={modalIsPinned} feature={pinnedFeature} onClose={closeThisWindow} />
                </div>
            </DragContainer>
        </>
    );
};
export { HoveredFeatureModal };
